<!-- Header with Logo and Freya Fusion Text -->
<div class="top-bar">
  <div class="logo">
    <img src="../../../../assets/images/Freya Fusion_Logo.svg" alt="Freya Fusion Text" class="freya-fusion-text">
  </div>
</div>

<!-- Session Name Header (Fixed) -->
<div class="session-name-header" *ngIf="sessionName && !loading && !error">
  <h2 class="session-name-title" [attr.data-tooltip]="sessionName" data-tooltip-position="bottom">{{ displaySessionName }}</h2>
</div>

<!-- Chat Content with top margin to account for fixed header -->
<div class="chat-content-wrapper">
  <div *ngIf="loading" class="loading-container">
    <div class="loader"></div>
    <p>{{'LOADING_SHARED_CHAT_TEXT' | translate}}</p>
  </div>

  <div *ngIf="error" class="error-container">
    <h3>{{ error | translate }}</h3>
  </div>

  <div *ngIf="!loading && !error && chatData" class="shared-chat-container">
    <div class="chat-expandable-area-new">
      <div class="response-history-area-new">
        <div class="scrollDiv" *ngFor="let chatItem of chatData; let i = index">
          <div class="card position-relative radius-6 clearfix">
            <!-- Question Section -->
            <div class="prompt-user-flexbox">
              <div class="prompt-user-text">
                <h6 class="m-t-0 m-b-0" [innerHTML]="chatItem.question">
                </h6>
              </div>
            </div>

            <!-- Answer Section -->
            <div class="card pull-left p-l-10 fullwidth chat-message-not-last-sq class1">
              <div class="response-info-total class1">
                <div class="response-info-icon class1">
                  <img [src]="agentIcon" [alt]="agentId">
                </div>
                <div class="response-info-text">
                  <!-- Tab Navigation -->
                  <!-- <div class="response-tabs"> -->
                    <!-- <div class="tab-nav">
                      <div class="tab-item active" data-tab="response" (click)="switchTab('response', $event)">
                        <i class="icon-chat"></i>
                        <span>Response</span>
                      </div>
                      <div class="tab-item" *ngIf="chatItem.newsAndUpdates && isNewsAndFeedsEnabled" data-tab="news" (click)="switchTab('news', $event)">
                        <img class="icon-megaphone" src="../../../assets/images/megaphone-icon.png" alt="Megaphone Icon">
                        <span>News & Updates ({{ chatItem.newsAndUpdates.length }})</span>
                      </div>
                    </div> -->
                    
                    <!-- Response Tab Content -->
                    <div class="tab-content active" id="response-tab">
                      <div class="row">
                        <div class="col-12">
                          <app-shared-response-renderer
                            [answer]="chatItem.answer"
                            [imageVisualization]="chatItem.image_visualization ?? ''"
                            [visualizationData]="chatItem.visualization ?? []"
                            [agentId]="agentId"
                            [fusionAppUiUrl]="fusionAppUiUrl"
                            [enableInsLinkNavigation]="false"
                            [showFileAttachmentActions]="false"
                            [enableTableInteractions]="false"
                            [isLoading]="false"
                            [isStreaming]="false"
                            [showLoadingIndicator]="false">
                          </app-shared-response-renderer>
                        </div>
                      </div>

                      <app-retrieval-mode-history-notice
                        *ngIf="agentId === 'regulations_agent'"
                        [retrievalMode]="chatItem.retrieval_mode"
                        [boxed]="true">
                      </app-retrieval-mode-history-notice>

                      <!-- Metadata Sources Section -->
                      <div class="metadata-sources" *ngIf="getMetadataItems(chatItem.metadata).length > 0">
                        <div class="metadata-container">
                          <div class="metadata-header">
                            <div class="metadata-title">
                              <span class="nowrap">{{'SOURCES' | translate}}</span>
                              <span class="metadata-count">{{ getMetadataItems(chatItem.metadata).length }}</span>
                            </div>
                          </div>

                          <!-- Sources Display -->
                          <div class="sources-display">
                            <div class="sourcerow">
                              <div *ngFor="let itemWithKey of getCurrentPageItemsWithKeys(chatItem.metadata, i); let itemIndex = index"
                                class="display-grid">
                                <div class="product-panel__bg1">
                                  <div class="product_panel">

                                    <!-- Universal Metadata Rendering -->
                                    <ng-container *ngIf="getModuleName(itemWithKey.item)">
                                      <div class="insight-header">
                                        <span class="relevance-dot" [class]="getRelevanceClass(getFieldValue(itemWithKey.item, 'relevance_score'))" 
                                              *ngIf="hasFieldValue(itemWithKey.item, 'relevance_score')"></span>
                                        <span class="regulation-id">{{ getDisplayId(itemWithKey.item) }}</span>
                                      </div>
                                      <h4 *ngIf="getDisplayTitle(itemWithKey.item)">{{ itemWithKey.key }}. {{ getDisplayTitle(itemWithKey.item) }}</h4>

                                      <!-- Categories (below title) -->
                                      <ng-container *ngIf="getCategoryDisplay(itemWithKey.item) as categoryDisplay">
                                        <span class="country-tag">
                                          <span class="country-text">
                                            {{ categoryDisplay.label }}
                                          </span>
                                        </span>
                                      </ng-container>
                                    </ng-container>

                                    <!-- Legacy Regulation Metadata -->
                                    <ng-container *ngIf="!getModuleName(itemWithKey.item) && getModuleNameFromMetadata(chatItem.metadata) === 'view_access_to_regulations'">
                                      <div class="insight-header">
                                        <span class="relevance-dot" [class]="getRelevanceClass(itemWithKey.item.relevance_score)" *ngIf="itemWithKey.item.relevance_score"></span><span class="regulation-id">{{ itemWithKey.item.ins_id }}</span>
                                      </div>
                                      <h4>{{ itemWithKey.key }}. {{ itemWithKey.item.title?.slice(0, 40) }}{{
                                        itemWithKey.item.title?.length > 40 ? '...' : '' }}</h4>

                                      <!-- Brand Names moved to the end of this section -->
                                      <div class="regulation__countries" *ngIf="extractBrandNames(itemWithKey.item).length > 0">
                                        <div class="regulation__country-item">
                                          <img src="assets/images/brand-icon.svg" alt="Brand" class="regulation__country-icon">
                                          <span class="regulation__country-text">
                                            {{ displayBrandNames(itemWithKey.item).firstTwo }}
                                            <span *ngIf="displayBrandNames(itemWithKey.item).remainingCount > 0">
                                              +{{ displayBrandNames(itemWithKey.item).remainingCount }}
                                            </span>
                                          </span>
                                        </div>
                                      </div>

                                      <!-- Countries moved to the end of this section -->
                                      <div class="regulation__countries" *ngIf="extractCountries(itemWithKey.item).length > 0">
                                        <div class="regulation__country-item">
                                          <img src="assets/images/location.svg" alt="Location" class="regulation__country-icon">
                                          <span class="regulation__country-text">
                                            {{ displayCountries(itemWithKey.item).firstTwo }}
                                            <span *ngIf="displayCountries(itemWithKey.item).remainingCount > 0">
                                              +{{ displayCountries(itemWithKey.item).remainingCount }}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </ng-container>

                                    <!-- Universal Detailed View Fields -->
                                    <ng-container *ngIf="getModuleName(itemWithKey.item)">
                                      
                                      <!-- Detailed View Fields for all modules -->
                                      <ng-container *ngFor="let field of getDetailedFields(itemWithKey.item)">
                                        <!-- Skip fields already displayed above -->
                                        <ng-container *ngIf="!field.key.includes('id') && !field.key.includes('title') && field.key !== 'relevance_score' && field.key !== 'explanation'">
                                          
                                          <!-- URL fields (references) -->
                                          <ng-container *ngIf="field.type === 'url' && hasFieldValue(itemWithKey.item, field.key)">
                                            <section class="regulation__section">
                                              <h4 class="regulation__section-title">{{ field.label | translate }}</h4>
                                              <div class="regulation__references">
                                                <div *ngFor="let url of getFieldValue(itemWithKey.item, field.key) | refUrl; let refIndex = index"
                                                  class="regulation__reference-unified">
                                                  <a [href]="url" target="_blank" class="regulation__reference-pill" rel="noopener noreferrer"
                                                     [attr.aria-label]="'Open ' + field.label.toLowerCase() + ' ' + (refIndex + 1) + ' in new tab'" 
                                                     [title]="url">
                                                    <span class="regulation__reference-text">{{ url.slice(0, 30) }}{{url.length > 30 ? '...' : ''}}</span>
                                                    ↗
                                                  </a>
                                                </div>
                                              </div>
                                            </section>
                                          </ng-container>

                                          <!-- Document fields — compact Concept 1 table -->
                                          <ng-container *ngIf="field.type === 'document' && hasFieldValue(itemWithKey.item, field.key)">
                                            <section class="regulation__section">
                                              <h4 class="regulation__section-title">{{ field.label | translate }}</h4>
                                              <ng-container *ngIf="getDocumentRows(itemWithKey.item) as docRows">
                                                <div class="metadata-doc-table" *ngIf="docRows.length > 0">
                                                  <div class="metadata-doc-table__head">
                                                    <span>{{ 'DOC_TABLE_DOCUMENT' | translate }}</span>
                                                    <span>{{ 'DOC_TABLE_VERSION' | translate }}</span>
                                                    <span>{{ 'DOC_TABLE_RELEASED' | translate }}</span>
                                                  </div>
                                                  <div class="metadata-doc-row"
                                                       *ngFor="let doc of getVisibleDocumentRows(itemWithKey.key, docRows); trackBy: trackByDocumentRow">
                                                    <span class="metadata-doc-name"
                                                          [attr.title]="getAttachmentDisplayName(doc.fileName)">{{ getAttachmentDisplayName(doc.fileName) }}</span>
                                                    <span class="metadata-doc-version"
                                                          [attr.title]="formatDocTableCell(doc.version)"
                                                          [attr.aria-label]="('DOC_TABLE_VERSION_TOOLTIP' | translate) + ': ' + formatDocTableCell(doc.version)">{{ formatDocTableCell(doc.version) }}</span>
                                                    <span class="metadata-doc-date"
                                                          [attr.title]="formatDocReleaseDate(doc.releaseDate)"
                                                          [attr.aria-label]="('DOC_TABLE_RELEASED_TOOLTIP' | translate) + ': ' + formatDocReleaseDate(doc.releaseDate)">{{ formatDocReleaseDate(doc.releaseDate) }}</span>
                                                  </div>
                                                  <button *ngIf="docRows.length > DOC_TABLE_PREVIEW_COUNT"
                                                          type="button"
                                                          class="metadata-doc-table__more"
                                                          (click)="toggleDocumentsExpanded(itemWithKey.key)"
                                                          [attr.aria-expanded]="isDocumentsExpanded(itemWithKey.key)">
                                                    <span *ngIf="!isDocumentsExpanded(itemWithKey.key)">
                                                      {{ 'DOC_TABLE_MORE' | translate:{ count: docRows.length - DOC_TABLE_PREVIEW_COUNT } }}
                                                    </span>
                                                    <span *ngIf="isDocumentsExpanded(itemWithKey.key)">
                                                      {{ 'DOC_TABLE_SHOW_LESS' | translate }}
                                                    </span>
                                                  </button>
                                                </div>
                                              </ng-container>
                                            </section>
                                          </ng-container>

                                          <!-- Brand Name fields -->
                                          <ng-container *ngIf="field.type === 'brandName' && hasFieldValue(itemWithKey.item, field.key)">
                                            <section class="regulation__section">
                                              <h4 class="regulation__section-title">{{ field.label | translate }}</h4>
                                              <div class="regulation__countries">
                                                <div class="regulation__country-item">
                                                  <img src="assets/images/brand-icon.svg" alt="Brand" class="regulation__country-icon">
                                                  <span class="regulation__country-text">
                                                    {{ displayCountries({ countries: getFieldValue(itemWithKey.item, field.key) }).firstTwo }}
                                                    <span *ngIf="displayCountries({ countries: getFieldValue(itemWithKey.item, field.key) }).remainingCount > 0">
                                                      +{{ displayCountries({ countries: getFieldValue(itemWithKey.item, field.key) }).remainingCount }}
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </section>
                                          </ng-container>

                                          <!-- Country fields -->
                                          <ng-container *ngIf="field.type === 'country' && hasFieldValue(itemWithKey.item, field.key)">
                                            <section class="regulation__section">
                                              <h4 class="regulation__section-title">{{ field.label | translate }}</h4>
                                              <div class="regulation__countries">
                                                <div class="regulation__country-item">
                                                  <img src="assets/images/location.svg" alt="Location" class="regulation__country-icon">
                                                  <span class="regulation__country-text">
                                                    {{ displayCountries({ countries: getFieldValue(itemWithKey.item, field.key) }).firstTwo }}
                                                    <span *ngIf="displayCountries({ countries: getFieldValue(itemWithKey.item, field.key) }).remainingCount > 0">
                                                      +{{ displayCountries({ countries: getFieldValue(itemWithKey.item, field.key) }).remainingCount }}
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </section>
                                          </ng-container>

                                          <!-- Date fields -->
                                          <ng-container *ngIf="field.type === 'date' && hasFieldValue(itemWithKey.item, field.key)">
                                            <section class="regulation__section">
                                              <h4 class="regulation__section-title">{{ field.label | translate }}</h4>
                                              <div class="regulation__metadata">
                                                <span class="regulation__metadata-value">{{ getFormattedFieldValue(itemWithKey.item, field) }}</span>
                                              </div>
                                            </section>
                                          </ng-container>

                                          <ng-container *ngIf="field.type === 'text' && hasFieldValue(itemWithKey.item, field.key)">
                                            <section class="regulation__section">
                                              <h4 class="regulation__section-title">{{ field.label | translate }}</h4>
                                              <div class="regulation__metadata">
                                                <span class="regulation__metadata-value">{{ getFormattedFieldValue(itemWithKey.item, field) }}</span>
                                              </div>
                                            </section>
                                          </ng-container>

                                        </ng-container>
                                      </ng-container>

                                      <!-- Brand Names (compact for all modules) - at the end -->
                                       <div class="countries-section"> 
                                      <ng-container *ngIf="extractBrandNames(itemWithKey.item).length > 0">
                                        <span class="country-tag">
                                          <span class="location-icon-wrapper">
                                            <img src="assets/images/brand-icon.svg" alt="Brand" class="location-icon" width="16" height="16">
                                          </span>
                                          <span class="country-text">
                                            {{ displayBrandNames(itemWithKey.item).firstTwo }}
                                            <span *ngIf="displayBrandNames(itemWithKey.item).remainingCount > 0">
                                              +{{ displayBrandNames(itemWithKey.item).remainingCount }}
                                            </span>
                                          </span>
                                        </span>
                                      </ng-container>

                                      <!-- Countries (compact for all modules) - at the end -->
                                      <ng-container *ngIf="extractCountries(itemWithKey.item).length > 0">
                                        <span class="country-tag">
                                          <span class="location-icon-wrapper">
                                            <img src="assets/images/location.svg" alt="Location" class="location-icon" width="16" height="16">
                                          </span>
                                          <span class="country-text">
                                            {{ displayCountries(itemWithKey.item).firstTwo }}
                                            <span *ngIf="displayCountries(itemWithKey.item).remainingCount > 0">
                                              +{{ displayCountries(itemWithKey.item).remainingCount }}
                                            </span>
                                          </span>
                                        </span>
                                      </ng-container>
                                      </div>
                                    </ng-container>

                                    <!-- Legacy RTQ Metadata -->
                                    <ng-container *ngIf="!getModuleName(itemWithKey.item) && getModuleNameFromMetadata(chatItem.metadata) === 'view_access_to_rtq'">
                                      <div class="insight-header">
                                        <span class="relevance-dot" [class]="getRelevanceClass(itemWithKey.item.relevance_score)" *ngIf="itemWithKey.item.relevance_score"></span><span class="rtq-id">{{ itemWithKey.item.rtq_id }}</span>
                                      </div>
                                      <h4 *ngIf="itemWithKey.item.query_title">
                                        {{ itemWithKey.key }}. {{ itemWithKey.item.query_title?.slice(0, 40) }}{{
                                        itemWithKey.item.query_title?.length > 40 ? '...' : '' }}
                                      </h4>

                                      <!-- RTQ Detailed Information -->
                                      <div class="metadata-detailed-info">
                                        <p class="metadata-detail" *ngIf="itemWithKey.item.product_id">
                                          <span class="metadata-label">{{'PRODUCT_ID' | translate}}</span>
                                          <span class="metadata-value">{{ itemWithKey.item.product_id }}</span>
                                        </p>
                                        <p class="metadata-detail" *ngIf="itemWithKey.item.productName">
                                          <span class="metadata-label">{{'PRODUCT' | translate}}</span>
                                          <span class="metadata-value">{{ itemWithKey.item.productName }}</span>
                                        </p>
                                        <p class="metadata-detail" *ngIf="itemWithKey.item.document_id">
                                          <span class="metadata-label">{{'DOCUMENT_ID' | translate}}</span>
                                          <span class="metadata-value">{{ itemWithKey.item.document_id }}</span>
                                        </p>
                                      </div>

                                      <p class="p-b-10" *ngIf="extractBrandNames(itemWithKey.item).length > 0">
                                        <span class="country-tag">
                                          <span class="location-icon-wrapper">
                                            <img src="assets/images/brand-icon.svg" alt="Brand" class="location-icon"
                                              width="16" height="16">
                                          </span>
                                          <span class="country-text">
                                            {{ displayBrandNames(itemWithKey.item).firstTwo }}
                                            <span *ngIf="displayBrandNames(itemWithKey.item).remainingCount > 0">
                                              +{{ displayBrandNames(itemWithKey.item).remainingCount }}
                                            </span>
                                          </span>
                                        </span>
                                      </p>

                                      <p class="p-b-10" *ngIf="extractCountries(itemWithKey.item).length > 0">
                                        <span class="country-tag">
                                          <span class="location-icon-wrapper">
                                            <img src="assets/images/location.svg" alt="Location" class="location-icon"
                                              width="16" height="16">
                                          </span>
                                          <span class="country-text">
                                            {{ displayCountries(itemWithKey.item).firstTwo }}
                                            <span *ngIf="displayCountries(itemWithKey.item).remainingCount > 0">
                                              +{{ displayCountries(itemWithKey.item).remainingCount }}
                                            </span>
                                          </span>
                                        </span>
                                      </p>
                                    </ng-container>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Slide Indicator with Arrows -->
                          <div class="slide-indicator" *ngIf="getMetadataItems(chatItem.metadata).length > itemsPerPage">
                            <button class="carousel-arrow left-arrow" (click)="prevSlide(i)" [disabled]="isPrevDisabled(i)">
                              ←
                            </button>
                            <span>{{ getCurrentIndex(i) + 1 }}-{{ getEndIndex(chatItem.metadata, i) }} {{'OF_TEXT' | translate}} {{
                              getMetadataItems(chatItem.metadata).length }}</span>
                            <button class="carousel-arrow right-arrow" (click)="nextSlide(i)"
                              [disabled]="isNextDisabled(chatItem.metadata, i)">
                              →
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Created Date Section -->
                      <div class="timestamp" *ngIf="chatItem.created_date">
                        <img src="./assets/images/icon-clock.svg" alt="Timestamp" title="{{'TIMESTAMP_TOOLTIP' | translate}}" />
                        <small>{{ chatItem.created_date}}</small>
                      </div>

                      <!-- Follow-up Questions Section -->
                      <div class="" *ngIf="chatItem.followup_questions && chatItem.followup_questions.length > 0">
                        <div class="followup-questions-total">
                          <h6 class="font-subheading1">{{'RELATED_QUESTIONS_TITLE_TEXT' | translate}}</h6>
                          <div class="followup-questions-list">
                            <div class="followup-question-item"
                              *ngFor="let fq of chatItem.followup_questions; let i = index">
                              <div class="followup-question-card">
                                {{fq}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- News & Updates Tab Content -->
                    <div class="tab-content" id="news-tab" *ngIf="isNewsAndFeedsEnabled">
                      <app-news-updates 
                        [newsItems]="chatItem.newsAndUpdates || []"
                        [news_feeds_id]="chatItem.news_feeds_id || null"
                        [isWebsocketCompleteAndDataSaved]="true"
                        [tenantId]="tenantId"
                        [domainId]="threadId"
                        [newsAndUpdatesnodata]="!chatItem.newsAndUpdates || chatItem.newsAndUpdates.length === 0"
                        (linkClick)="onNewsLinkClick($event)">
                      </app-news-updates>
                    </div>
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !error && (!chatData || chatData.length === 0)" class="error-container">
    <h3>{{'NO_DATA_FOUND_TEXT' | translate}}</h3>
    <p>{{'NO_CHAT_DATA_FOUND_TEXT' | translate}}</p>
  </div>
</div>
